import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { api } from "../services/api";
import { forViewer, templatesQuery, TEMPLATES_QUERY_KEY, viewerIdOf } from "../services/queries";

export type ApiTemplate = Awaited<
  ReturnType<typeof api.templates.getAll>
>["templates"][number];

// Prefix of every Templates query; invalidate it after creating, editing or
// removing a Template.
export { TEMPLATES_QUERY_KEY };

// Shares the fetch and cache only: pages map the API shape themselves via
// `select` (keep it a stable reference, e.g. module-level).
export const useTemplates = <T>({
  select,
  enabled = true,
}: {
  select: (templates: ApiTemplate[]) => T;
  enabled?: boolean;
}) => {
  const { user, token } = useAuth();
  return useQuery({
    ...forViewer(templatesQuery(user?.schoolId, token), viewerIdOf(user)),
    select,
    enabled: !!token && !!user?.schoolId && enabled,
  });
};
